import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { VesselDwtTypesContext } from '../HiresPage';
import BasicSelector from '../../TcIndex/Basic/BasicSelector';

function DwtGroup({ 
    vesselType, 
    changeFieldsMultiple, 
    countIndex, 
    required = false, 
    setHasErrors, 
    disabled = false,
    currentDwtGroups,
}) {
    const vesselDwtTypes = useContext(VesselDwtTypesContext);

    const selectVesselType = (_id) => {
        const toChange = [
            {
                index: countIndex,
                field: 'vesselDwtGroup',
                value: vesselDwtTypes.find(t => t._id === _id),
            },
            {
                index: countIndex,
                field: 'vessel',
                value: undefined,
            },
        ];

        changeFieldsMultiple(toChange);
    };

    useEffect(() => {
        if (required) {
            if (!vesselType || !vesselType._id) {
                setHasErrors('vesselDwtGroup', true);
            } else {
                setHasErrors('vesselDwtGroup', false);
            }
        }
    }, [vesselType]);

    return (
        <BasicSelector 
            value={vesselType && vesselType._id}
            dataList={currentDwtGroups}
            onChange={(e, _i, value) => selectVesselType(value)}
            iconStyle={{ display: 'none' }}
            underlineStyle={{ display: 'none' }}
            style={{ fontSize: '9px' }}
            labelStyle={{ padding: 0, top: 'unset' }}
            fields={['min', 'max']}
            disabled={disabled}
        />
    );
}

DwtGroup.protoTypes = {
    vesselType: PropTypes.shape({
        _id: PropTypes.string,
        max: PropTypes.number,
        min: PropTypes.number,
        name: PropTypes.string,
    }),
    changeFieldsMultiple: PropTypes.func,
    countIndex: PropTypes.number,
};


export default React.memo(DwtGroup);



// WEBPACK FOOTER //
// ./app/components/Hires/rowData/DwtGroup.jsx